import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Mic, List, Menu, X, Shield, LogOut } from "lucide-react";
import "./NavBar.css";
import { AuthContext } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const NavBar = () => {
  const { pathname } = useLocation();
  const { isAuthenticated, logout } = useContext(AuthContext);
  const [role, setRole] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Only run on mount
    const fetchRole = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const roleRes = await fetch(`${API_URL}/auth/get_role`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (roleRes.ok) {
          const roleData = await roleRes.json();
          setRole(roleData.role);
        }
      } catch { /* ignore */ }
    };
    if (isAuthenticated) fetchRole();
  }, [isAuthenticated]);

  // Close menu on route change (mobile)
  useEffect(() => { setMenuOpen(false); }, [pathname]);

  // Logout handler
  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-brand">
          <span className="navbar-logo">
            <Mic size={22} color="#7848e6" />
          </span>
          <span className="navbar-title">VocalizeIQ</span>
        </div>

        {/* Hamburger icon - mobile only */}
        <button
          className="navbar-hamburger"
          aria-label="Open menu"
          onClick={() => setMenuOpen(m => !m)}
        >
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Desktop nav links */}
        <div className="navbar-links">
          <Link to="/" className={pathname === "/" ? "active" : ""}>
            <List size={18} style={{ marginRight: 6 }} />
            Recordings
          </Link>
          {role === "site_admin" && (
            <Link to="/admin" className={pathname === "/admin" ? "active" : ""}>
              <Shield size={16} style={{ marginRight: 6 }} />
              Admin
            </Link>
          )}
          {isAuthenticated && (
            <button className="navbar-logout-btn" onClick={handleLogout} tabIndex={0}>
              <LogOut size={17} style={{ marginRight: 6, marginLeft: 2 }} />
              Logout
            </button>
          )}
        </div>

        {/* Mobile slideout menu */}
        <div className={`navbar-mobile-menu${menuOpen ? " open" : ""}`}>
          <Link to="/" className={pathname === "/" ? "active" : ""}>
            <List size={18} style={{ marginRight: 6 }} />
            Recordings
          </Link>
          {role === "site_admin" && (
            <Link to="/admin" className={pathname === "/admin" ? "active" : ""}>
              <Shield size={16} style={{ marginRight: 6 }} />
              Admin
            </Link>
          )}
          {isAuthenticated && (
            <button className="navbar-logout-btn" onClick={handleLogout} tabIndex={0}>
              <LogOut size={17} style={{ marginRight: 6, marginLeft: 2 }} />
              Logout
            </button>
          )}
        </div>
      </div>
      {menuOpen && <div className="navbar-overlay" onClick={() => setMenuOpen(false)} />}
    </nav>
  );
};

export default NavBar;
